import { SxProps, TableCell, Theme } from '@mui/material'
import React, { ReactNode } from 'react'
import theme from 'theme'

type Props = {
  columnLength: number
  columnIndex: number
  header?: boolean
  sortHeader?: boolean
  tableBodyCell?: boolean
  children?: ReactNode
  color?: SxProps<Theme>
}

const TableElementTableCell: React.FC<Props> = ({
  columnLength,
  columnIndex,
  children,
  sortHeader = false,
  tableBodyCell = false,
  header = false,
  color = {},
}) => {
  let styles: SxProps<Theme> = {
    minWidth: columnIndex === 0 ? '240px' : '',
    position: columnIndex === 0 ? 'sticky' : '',
    zIndex: columnIndex === 0 ? 1 : 0,
    left: columnIndex === 0 ? 0 : '',
    backgroundColor: columnIndex === 0 ? 'white' : '',
    paddingLeft: columnIndex === 0 ? theme.spacing(4.5) : '',
    paddingRight: columnIndex === columnLength - 1 ? '62px' : '',
  }

  if (header) {
    styles.paddingTop = '0px'
  }

  if (sortHeader) {
    styles.paddingTop = '0px'
    styles.paddingBottom = '0px'
    styles.borderBottom = '0px solid #fff'
  }

  if (tableBodyCell) {
    if (columnIndex !== 0) {
      styles.minWidth = '125px'
    }
    if (color) {
      styles = { ...styles, ...color }
    }
  }

  return <TableCell sx={styles}>{children}</TableCell>
}

export default TableElementTableCell
